import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { MagnifyingGlass } from "@phosphor-icons/react";

const FOLDER_TABS = [
  { value: "", label: "Sve", dot: "bg-foreground/40" },
  { value: "profiles", label: "Profili", dot: "bg-blue-500" },
  { value: "services", label: "Usluge", dot: "bg-primary" },
  { value: "blog", label: "Blog", dot: "bg-amber-500" },
  { value: "documents", label: "Dokumenti", dot: "bg-emerald-500" },
] as const;

export function MediaFolderTabs({
  folder,
  searchQuery,
  onFolderChange,
  onSearchChange,
}: {
  folder: string;
  searchQuery: string;
  onFolderChange: (value: string) => void;
  onSearchChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
      <div className="flex w-full gap-1.5 overflow-x-auto rounded-xl bg-muted/60 p-1.5 md:w-auto">
        {FOLDER_TABS.map((tab) => {
          const isActive = folder === tab.value;
          return (
            <button
              key={tab.value}
              onClick={() => onFolderChange(tab.value)}
              className={cn(
                "flex shrink-0 items-center justify-center gap-1.5 rounded-lg px-2 py-2 text-sm font-medium transition-all duration-200",
                isActive
                  ? "bg-background text-foreground shadow-sm ring-1 ring-border/50"
                  : "text-muted-foreground hover:text-foreground"
              )}
            >
              <span
                className={cn(
                  "size-2 shrink-0 rounded-full transition-colors",
                  isActive ? tab.dot : "bg-muted-foreground/30"
                )}
              />
              <span className="truncate">{tab.label}</span>
            </button>
          );
        })}
      </div>

      <div className="relative w-full md:w-72">
        <MagnifyingGlass className="absolute left-3 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Pretraži fajlove..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
    </div>
  );
}
